import React from "react";
import { Helmet } from "react-helmet";

function MillwoodsCallLogDocs() {
  return (
    <div className="w-full h-screen flex justify-center items-center bg-gray-100 p-4">
      <Helmet>
        <meta charSet="utf-8" />
        <title>CRM Call Log User Guide | Millwoods Travels</title>
      </Helmet>
      <div className="w-full h-full max-w-4xl p-4 bg-white shadow-lg rounded-lg">
        <iframe
          src="https://docs.google.com/document/d/1KckQPo9bPn_SJx4yg-Qw0KkR8bvNzKSZFoBo4AcJKx4/preview"
          className="w-full h-full"
        ></iframe>
      </div>
    </div>
  );
}

export default MillwoodsCallLogDocs;
